import React, { Component, useState } from 'react';
import { useHistory } from "react-router-dom";
import { withStyles, createMuiTheme, ThemeProvider, useTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Username, Password } from '../../components/textInput';
import { Btn } from '../../components/global';
import { AuthForm } from '../../components/authForm'
import { USezpayAuthForm } from '../../components/authForm/USezpayAuthForm'
import { withProfile } from "../profile";
import LegacyLogin from './legacyLogin';
import { signin_styles } from './styles';
import { getPaswordRecoverMethods } from '../../APIs';

export default withProfile(withStyles(signin_styles)((props) => {
    const {
        classes,
        signInFieldsInfo,
        signInHandler,
        setInputField,
        onSignInSuccess,
        onSignInError,
        loading,
        state,
        validateTemp,
        validationFailed,
        fromDomain,
        selectPhoneOrEmail,
        phoneOrEmail,
        messagePool,
        clearUsernameError,
        usernameError,
        errorMessage,
        isUSezpay
    } = props;
    const history = useHistory();
    console.log('Signin messagePool:', props.messagePool);
    console.log('Signin locale:', props.locale);
    const { 
        PASSWORD, 
        FORGET_PASSWORD, 
        SIGN_IN,
        PLEASE_INPUT_EMAIL_PHONE,
        INVITATION_NOT_CONFIRMED,
        NO_VERIFIED_CONTACT,
        USER_NOT_EXISTS,
        WELCOME_TO_MENUSIFU,
        BY_LOGGING_IN,
        TERMS_OF_USE,
        AND,
        PRIVACY_POLICY
    } = props.messagePool || {};
    console.log('Signin extracted values:', { BY_LOGGING_IN, TERMS_OF_USE, AND, PRIVACY_POLICY });
    const [migrationOn, setMigrationOn] = useState(false);
    const theme = useTheme();
    const fullscreen = useMediaQuery(theme.breakpoints.down('sm'))
    const signInFields = signInFieldsInfo.map(field => {
        if (field.field == "userName") {
            let username = state[field.field];
            return (
                <div className={classes.input}>
                    <Username 
                        inputProps={{'cy-test': 'username'}}
                        label={messagePool[phoneOrEmail.toUpperCase()]} 
                        helperMsg={field.helperMsg}
                        onChange={setInputField(field.field)}
                        refNode={field.node}
                        defaultValue={state[field.field]}
                        value={username}
                        type={phoneOrEmail}
                        onChangeType={selectPhoneOrEmail}
                        error={usernameError}
                        errMesssage={errorMessage}
                        onClick={clearUsernameError}
                    />
                </div>
            )
        } else {
            return (
                <div key={field.title} style={{width: '100%'}}>
                    <Password label={PASSWORD}
                        inputProps={{'cy-test': 'password'}}
                        onChange={setInputField(field.field)}
                        onKeyDown={(e) => { 
                            if (e.keyCode == 13) {
                                signInHandler();
                            }
                        }}/>
                </div>
            )
        }
    });

    const onClickForgetPw = async () => {
        const { userName } = state;
        if (!userName) {
            alert(PLEASE_INPUT_EMAIL_PHONE || "Please input email or phone.")
        } 
        try {
            let params = {}
            if (phoneOrEmail == "email") {
                params.email = userName;
            } else {
                params.phone = "+1" + userName
            }
            const pwRecoverMethods = await getPaswordRecoverMethods(params);
            const { confirmed, phoneVerified, emailVerified, phone, email } = pwRecoverMethods.data;
            if (!confirmed) {
                alert(INVITATION_NOT_CONFIRMED || "You haven't confirmed the invitation yet. Please use the invitation link to change the temporary password. If you cannot find the invitation link, please contact customer service to resend.")
                return;
            }
            if (!phoneVerified && !emailVerified) {
                alert(NO_VERIFIED_CONTACT || "You don't have any verified phone or email. Please contact customer service.")
                return;
            }
            const method = encodeURIComponent(JSON.stringify({
                phone_number: phone,
                email,
                phone_number_verified: phoneVerified,
                email_verified: emailVerified,
                confirmed,
                username: phoneOrEmail == "email"? userName: "+1" + userName
            }))
            // Always use /recoverPassword - it will auto-detect branding from redirect_uri
            history.push(`/recoverPassword${window.location.search}&method=${method}`)
        } catch(err) {
            if (err?.response?.data?.code === "USER_NOT_FOUND") {
                alert(USER_NOT_EXISTS || "User not exists. Please check the email or phone number.")
                return;
            }
        }
    }
    // Determine branding based on isUSezpay flag
    const FormComponent = isUSezpay ? USezpayAuthForm : AuthForm;
    const title = isUSezpay ? "Welcome to USezPay" : (WELCOME_TO_MENUSIFU || "Welcome to MenuSifu");
    const termsUrl = isUSezpay ? "https://www.usezpay.com/usezpay-terms-and-condition/" : "https://www.menusifu.com/terms";
    const privacyUrl = isUSezpay ? "https://www.usezpay.com/privacy" : "https://www.menusifu.com/privacy";
    const loginByText = isUSezpay ? "By logging in, you agree to USezPay's " : (BY_LOGGING_IN || "By logging in, you agree to Menusifu's ");

    return (
        <div>
        {
            validateTemp ?
            <div>Validating...</div> :
            validationFailed ?
            <div>The link is not valid</div> :
            <div>
                <FormComponent title={title}>
                    <div className={classes.inputFields}>
                        { signInFields }
                    </div>
                    <a  cy-test='forgot-pwd'
                        className={classes.forgetPassword}
                        onClick={onClickForgetPw}
                    >
                        {`${FORGET_PASSWORD}`}
                    </a>
                    <Btn variant="contained"
                            color="primary"
                            className={classes.button}
                            style={isUSezpay ? { backgroundColor: '#d9b97f', color: '#fff' } : {}}
                            onClick={signInHandler}>
                        {loading? <CircularProgress color="secondary" /> : SIGN_IN}
                    </Btn>
                    <div style={{marginTop: "50px" }}>
                        <span>{loginByText}</span>
                        <a href={termsUrl}>{TERMS_OF_USE || "Terms of Use"}</a>
                        <span>{` ${AND || " and "}`}</span>
                        <a href={privacyUrl}>{PRIVACY_POLICY || "Privacy Policy"}</a>
                    </div>
                </FormComponent>
            </div>
        }
        <Dialog className={classes.dialog} open={migrationOn}
            onClose={() => setMigrationOn(false)}
            fullScreen={fullscreen}
        >
            <LegacyLogin
                onSignInSuccess={onSignInSuccess}
                onSignInError={onSignInError}
                onClose={() => setMigrationOn(false)}/>
        </Dialog>
        </div>
    )
}),["profile","logout", "switch_business"])